import { __awaiter, __generator } from "tslib";
import { useCallback } from "react";
import { getAdminApiUrl } from "@adsk/acs-sc-web-platform-api";
import { useRequests } from "./useRequests";
import { fetchAll } from "../utils/fetchHelpers";
export var useAccounts = function () {
    var fetchFn = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetchAccounts, accountsResponse, accounts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fetchAccounts = function () {
                        return fetchAll("".concat(getAdminApiUrl(), "/v1/accounts"));
                    };
                    return [4 /*yield*/, fetchAccounts()];
                case 1:
                    accountsResponse = _a.sent();
                    accounts = accountsResponse.filter(function (rawAccount) { return rawAccount.isAccEligible; });
                    // Return the transformed type
                    return [2 /*return*/, { data: accounts }];
            }
        });
    }); }, []);
    return useRequests(fetchFn);
};
